export const WEB_URL = process.env.REACT_APP_WEB_URL ?? "http://localhost:3000";

export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL ?? "http://localhost:3001";

export const API_URL = process.env.REACT_APP_API_URL ?? "http://localhost:3001/api/v1/";

export const BACKEND_ROOT_URL = process.env.REACT_APP_BACKEND_ROOT_URL ?? "http://localhost:3001";